//* ============================= Types =======================================

import { useEffect, useState } from 'react'
import { animated, useSpring } from 'react-spring'
import styled from 'styled-components'

//* ============================= Types =======================================

type SkipSecondsDisplayProps = {
  seconds: number
}

//* ============================= React Component =======================================

const SkipSecondsDisplay = ({ seconds }: SkipSecondsDisplayProps): JSX.Element => {
  const [opacity, setOpacity] = useState(0)

  // This buffer prevents the UI from displaying 0 when the seconds paramenter is 0.
  // It would look awkward and with the buffer it just shows the previous value.
  const [secondsBuffer, setSecondsBuffer] = useState(0)

  useEffect(() => {
    if (seconds != 0) {
      setSecondsBuffer(seconds)
    }
  }, [seconds])

  // When the skipping begins, and therefore the seconds change, then the animation should start
  // by setting the max values.
  // The animation ends by setting the min values. These are set as soon as the skipping ends, cause
  // then the seconds change to 0.
  useEffect(() => {
    if (seconds != 0) {
      // Max values
      setOpacity(1)
    } else {
      // Min values
      setOpacity(0)
    }
  }, [seconds])

  const trail = useSpring({
    opacity: opacity,
    config: {
      duration: 110,
    },
  })

  return <AnimatedText style={trail}>{secondsBuffer}</AnimatedText>
}

export default SkipSecondsDisplay

//* ============================= Styled Components =======================================

const Text = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
  user-select: none;
`

const AnimatedText = animated(Text)
